export default function NosEngagements() {
  const engagements = [
    {
      icon: "ri-map-pin-line",
      title: "Proximité",
      desc: "Notre atelier est situé à Strasbourg, au cœur du Bas-Rhin. Nous intervenons rapidement dans toute l'agglomération et les communes environnantes, avec des délais souvent de 24h.",
    },
    {
      icon: "ri-tools-line",
      title: "Réparer plutôt que remplacer",
      desc: "Nous réparons la pièce défectueuse sur place, sans remplacer toute la fenêtre. Cette approche permet de réparer dans plus de 90% des cas, à un coût bien plus accessible.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Devis et déplacement gratuits",
      desc: "Le déplacement et le diagnostic sont totalement gratuits. Le technicien vous donne un devis précis avant toute intervention, et vous ne payez que la réparation et la pièce.",
    },
    {
      icon: "ri-award-line",
      title: "Garantie 10 ans",
      desc: "Chaque pièce de quincaillerie remplacée est garantie 10 ans. Nous utilisons des pièces neuves de qualité pour toutes les marques : Ferco, GU, Roto, Maco, Siegenia.",
    },
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4">
            Nos engagements
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed">
            Chez DF PRO, nous nous engageons à fournir un service de qualité, transparent et proche de nos clients.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {engagements.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 md:p-6 border border-rose-100"
            >
              <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-plum text-xl`} />
              </div>
              <h3 className="font-semibold text-base md:text-lg text-plum-dark mb-2">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-plum-dark/70 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}